export enum TruckSize {
  'any' = 'any',
  '8A' = '8A',
  '6A' = '6A',
  'MA' = 'MA',
}

export function formatTruckSize(size: TruckSize) {
  const mappings = {
    'any': `Any Truck Size`,
    '8A': `8-Wheeler max`,
    '6A': `6-Wheeler max`,
    'MA': `Mini only`,
  }
  return mappings[size]
}
